import { WriteHook, useMutationManager } from 'state-manager'

import { putApplicationClientDocument } from './services'
import { ApplicationDocumentUpdatePayload } from './types'

export const usePutApplicationClientDocument: WriteHook<ApplicationDocumentUpdatePayload, unknown> = (opts) =>
  useMutationManager<ApplicationDocumentUpdatePayload, unknown>(putApplicationClientDocument, opts)
